











































import Vue from "vue";
export default Vue.extend({
    name: "DocumentToolbarTranslateButton",
    components: {},
    props: {
        isTranslatedVersion: Boolean
    },
    computed: {
        xs(): boolean {
            return this.$vuetify.breakpoint.xs;
        }
    },
    methods: {
        toggleTranslation(isTranslated: boolean) {
            this.$emit("change-translation", isTranslated);
        }
    }
});
